import { render, staticRenderFns } from "./DatosFiscales.vue?vue&type=template&id=45498cda"
import script from "./DatosFiscales.vue?vue&type=script&lang=js"
export * from "./DatosFiscales.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports